import { Message } from '../components/Messages'
import { ContentfulAsset } from '../data/contentful.api'
import { Disturbance } from '../data/travelinfo-disturbance.api'

export function mapContentfulMessageAndDisturbancesToMessages(
  disturbances: Disturbance[],
  contentfulMessage: ContentfulAsset | undefined,
): Message[] {
  const messages: Message[] = disturbances.map((disturbance) => ({
    description: disturbance.description,
  }))

  // if contentfulMessage is present, place it at the beginning of the array
  if (contentfulMessage?.fields?.description) {
    messages.unshift({ description: contentfulMessage.fields.description })
  }

  return messages
}

export function hasLongMessage(messages: Message[]) {
  return messages.some((message) => message.description.length > 230)
}

export function getAmountOfMessageRows(
  messages: Message[],
  hasLongMessage: boolean,
) {
  if (messages.length === 0) {
    return 0
  }
  return hasLongMessage ? 2 : 1
}
